import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";

const product = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/blog", label: "Blog" },
];

const company = [
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const legal = [
  { to: "/privacy", label: "Privacy Policy", external: true },
  { to: "/terms", label: "Terms of Service", external: true },
];

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-950">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <Logo size={28} />
              <span className="text-sm font-semibold tracking-tight text-gray-900 dark:text-white">
                Paysafi
              </span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
              Rent tracking and tenant management for landlords and property managers in Kenya.
            </p>
          </div>
          <FooterCol title="Product" links={product} />
          <FooterCol title="Company" links={company} />
          <FooterCol title="Legal" links={legal} />
        </div>
        <div className="mt-10 border-t border-gray-100 pt-6 text-center text-xs text-gray-400 dark:border-gray-800">
          &copy; {new Date().getFullYear()} Paysafi. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-900 dark:text-white">{title}</h3>
      <ul className="mt-3 space-y-2">
        {links.map((l) => (
          <li key={l.label}>
            {l.external ? (
              <a
                href={l.to}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
              >
                {l.label}
              </a>
            ) : (
              <Link to={l.to} className="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                {l.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
